import React from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { Grid } from "@material-ui/core";
import { Card } from "../common/card/card";
import { useWorkOrderStyles, CardTitle } from "./workOrderDetails";
import ActivityQuestion, { activityQuestionStyles } from "./activityQuestion";

const WorkOrderActivityInfo = ({ count, WorkActivitydetails }) => {
    const classes = { ...useWorkOrderStyles(), ...activityQuestionStyles() };
    const intl = useIntl();
    // fetch and parse the question data
    const activityQuestionData = WorkActivitydetails?.activityQuestions ? WorkActivitydetails?.activityQuestions : null;
    const questionAnswerJSON = WorkActivitydetails?.activityQuestionJson ? JSON.parse(WorkActivitydetails?.activityQuestionJson) : null;
    const activityQuestions = activityQuestionData.sort((a, b) => a.displayOrder - b.displayOrder);
    const activityQuestionComment = WorkActivitydetails?.activityQuestionComment ? JSON.parse(WorkActivitydetails?.activityQuestionComment) : null;
    // renders the activity as readonly as the activity may not be
    // changed after the WO is created

    let activityHeader = "";
    if (intl.locale == "en") {
        switch (WorkActivitydetails?.activity_Id) {
            case 296:
                activityHeader = "Buried Service Wire";
                break;
            case 299:
                activityHeader = "Place Cable - Buried (Bell cable tech use only)";
                break;
            default:
                activityHeader = WorkActivitydetails?.activityNameEn;
        }
    } else {
        switch (WorkActivitydetails?.activity_Id) {
            case 296:
                activityHeader = "Fils de Service Enfoui";
                break;
            case 299:
                activityHeader = "Placer le câble - Enfouis (Réservé aux techniciens des câbles Bell)";
                break;
            default:
                activityHeader = WorkActivitydetails?.activityNameFr;
        }
    }

    return (
        <Card>
            <CardTitle>
                <FormattedMessage id="admin.work-order-details.wo-info.work-activity-caption" />
                {" " + count + ": " + activityHeader}
            </CardTitle>

            <Grid container spacing={4} className={classes.row}>
                {activityQuestions.map((question) => (
                    <Grid item xs={4} className={classes.activityQuestion} key={question.id}>
                        <ActivityQuestion
                            question={question}
                            value={questionAnswerJSON ? questionAnswerJSON[question.id] : null}
                            language={intl.locale}
                            activityQuestionComment={activityQuestionComment}
                        />
                    </Grid>
                ))}
            </Grid>
        </Card>
    );
};

export default WorkOrderActivityInfo;
